import "./VisionHero.css";

export default function VisionHero() {
  return (
    <div id="vision-hero" className="outsourcemainclass">
      <div className="left">
        <h1>
          <strong>Computer Vision</strong> Solutions and Services
        </h1>
        <p>
          We help businesses design, migrate, and optimize cloud environments
          with secure, scalable strategies that drive agility, innovation, and
          faster time-to-value across the enterprise.
        </p>
      </div>
    </div>
  );
}
